import { render, staticRenderFns } from "./BenefitGiftTabs.vue?vue&type=template&id=63078835"
import script from "./BenefitGiftTabs.vue?vue&type=script&lang=js"
export * from "./BenefitGiftTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports